import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TeamService } from 'src/app/private/services/teams.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-update-team',
  templateUrl: './update-team.component.html',
  styleUrls: ['./update-team.component.scss']
})
export class UpdateTeamComponent {
  @Input() editTeamData: any;
  @Output() close = new EventEmitter();
  @Output() handleChangeName = new EventEmitter();
  btnLoading = false;

  teamname: any;


  constructor(
    private localstorage: LocalStorageService,
    private api: TeamService,
    private toaster: ToastrService,
    private tracker: TrackingService,

  ) { }

  ngOnInit() {
    this.teamname = this.editTeamData.name;
  }


 
  closeModal() {
    this.close.emit();
  }

  saveTeam(isValid: any): void {
    if (isValid) {

      const payload = {
         "team_id": this.editTeamData.team_id,
         "name": this.teamname,
      };

      this.btnLoading = true;

      this.api.updateTeam(payload).subscribe({
        next: (res) => {
          this.btnLoading = false;
          this.toaster.success(res.message || 'Team Created Successfully');
          this.tracker.track("Update", "Team", `Team updated: ${payload.name} (ID: ${payload.team_id})`);

          this.handleChangeName.emit(this.teamname);
          this.close.emit();
        }
        , error: (err) => {
          this.btnLoading = false;
          this.close.emit();
          this.toaster.error(err.error.message || 'Something went wrong');
        }
      });

    }
  }
}
